/// <reference path="./API.d.ts" />
import request from './request';
import request2 from './request2'
 
export async function GetCityInfo() {
  return request.get<API.CityInfoData>('cities/cities');
}

// 获取城市天气信息
export async function GetWeather(cityCode?: string) {
  return request.get<API.WeatherForecast>('common/gaode/weather/info', {
    params: {
      cityCode,
    }
  });
}
export async function GetCityAreaInfo(cityCode?: string,queryTime?:string) {
  return request.get<API.AreaInfoData>('area', {
    params: {
      cityCode,
      queryTime
    }
  });
}

export async function GetCityWeather(cityCode?: string) {
  return request.get('common/weather/info', {
    params: {
      cityCode
    }
  })
}

export async function GetRoadListByCity(areaCode?: string,trialRunStatus?: string) {
  return request.get<API.RoadList>('road-section', {
    params: {
      areaCode,
      trialRunStatus
    }
  })
}

export async function GetDeviceStatic(areaCode?:string){
return request.get('resource/device-static',{
  params:{
    areaCode
  }
})
}
export async function GetResourceDeviceStatic(areaCode?:string){
return request2.get('tvs-traffic/p-api/v2/resource/device-static',{
  params:{
    areaCode
  }
})
}

export async function GetParkAlarm(areaCode?: string) {
  return request.get<API.ParkAlarmData>('resource/alarm', {
    params: {
      areaCode
    }
  })
}

export async function GetParkRank(params: {
  areaCode?: string;
  limit?:number;
}) {
  return request.get('resource/park-rank', {
    params
  })
}
export async function GetRoadRank(params: {
  areaCode?: string;
  limit?:number;
}) {
  return request.get('resource/road-rank', {
    params
  })
}
// 新接入停车场
export async function GetIncomeJoinParkList(params: {
  areaCode?: string;
  cityCode?: string | number;
  limit?:number;
}) {
  return request2.get('tvs-traffic/p-api/v2/operate/income/join-park/list', {
    params
  })
}

export async function GetDistributeData(areaCode?: string) {
  return request.get<API.DistributeData[]>('resource/distribute', {
    params: {
      areaCode
    }
  })
}
export async function GetResourceDistribute(areaCode?: string) {
  return request2.get<API.DistributeData[]>('tvs-traffic/p-api/v2/resource/distribute', {
    params: {
      areaCode
    }
  })
}

export async function GetDifficultParkOrRoad(params: {
  areaCode?: string,
  limit?:string
}) {
  return request.get('resource/park-difficult', {
    params
  })
}
export async function GetDifficultRoadOrRoad(params: {
  areaCode?: string
  limit?:string
}) {
  return request.get('resource/road-difficult', {
    params
  })
}

export async function GetServiceIncomeRank(areaCode?: string) {
  return request.get<API.ServiceIncomeRank[]>('operate/income/add-service/rank', {
    params: {
      areaCode
    }
  })
}

export async function GetIncomeTrendDay(areaCode?: string,cityCode?: string) {
  return request.get<API.IncomeTrendDay[]>('operate/income/trend/day', {
    params: {
      areaCode,
      cityCode
    }
  })
}
export async function GetIncomeTrendDayV2(areaCode?: string,cityCode?: string) {
  return request2.get('tvs-traffic/p-api/v2/operate/income/trend/day', {
    params: {
      areaCode,
      cityCode
    }
  })
}

export async function GetIncomeTrendMonth(areaCode?: string,cityCode?: string) {
  return request.get<API.IncomeTrendMothy[]>('operate/income/trend/month', {
    params: {
      areaCode,
      cityCode
    }
  })
}
export async function GetIncomeTrendMonthV2(areaCode?: string,cityCode?: string) {
  return request2.get('tvs-traffic/p-api/v2/operate/income/trend/month', {
    params: {
      areaCode,
      cityCode
    }
  })
}
export async function GetAddIncomeRank(areaCode?: string,cityCode?: string) {
  return request.get('operate/income/add-income/rank', {
    params: {
      areaCode,
      cityCode
    }
  })
}
// 充值收入
export async function GetAddIncomeRankV2(areaCode?: string,cityCode?: string) {
  return request2.get('tvs-traffic/p-api/v2/operate/income/recharge-income/rank', {
    params: {
      areaCode,
      cityCode
    }
  })
}
// 充值收入
export async function GetMonthIncomeRank(areaCode?: string,cityCode?: string) {
  return request2.get('tvs-traffic/p-api/v2/operate/income/month-income/rank', {
    params: {
      areaCode,
      cityCode
    }
  })
}

export async function GetJoinParkIncomeRank(areaCode?: string,dataType?:string) {
  return request.get<API.JoinParkIncomeRank[]>('operate/income/join-park/rank', {
    params: {
      areaCode,
      dataType,
    }
  })
}
export async function GetSimpleTvsInspectorAll(areaCode?: string) {
  return request2.get('tvs-traffic/p-api/v2/supervise/simple/tvs-inspector-all', {
    params: {
      areaCode,
    }
  })
}

export async function GetJoinParkIncomeRankV2(areaCode?: string,dataType?:string) {
  return request2.get<API.JoinParkIncomeRank[]>('tvs-traffic/p-api/v2/operate/income/join-park/rank', {
    params: {
      areaCode,
      dataType,
    }
  })
}

export async function GetJoinParkNew(areaCode?: string) {
  return request.get<API.JoinParkNew[]>('operate/income/join-park/new', {
    params: {
      areaCode
    }
  })
}

export async function GetIllegalPark(areaCode?: string,limit?: string) {
  return request.get<API.IllegalParkData[]>('supervise/illegal-park', {
    params: {
      areaCode,
      limit
    }
  })
}

export async function GetunPaidCar(areaCode?:string,limit?: string) {
  return  request.get<API.UnpaidCarData[]>('supervise/unpaid-car',{
    params:{
      areaCode,
      limit
    }
  })
}
//<API.InspectorReport[]>
export async function GetInspectorReport(areaCode?: string) {
  return request.get('supervise/inspector/report', {
    params: {
      areaCode,
      pageNum:'1',
      pageSize:'15'
    }
  })
}
export async function GetInspectorReportV2(areaCode?: string) {
  return request2.get('tvs-traffic/p-api/v2/supervise/inspector/report', {
    params: {
      areaCode,
      pageNum:'1',
      pageSize:'15'
    }
  })
}

export async function GetCarBreakData(areaCode?: string,limit?: string) {
  return request.get<API.CarBreakData[]>('supervise/break', {
    params: {
      areaCode,
      limit
    }
  })
}

export async function GetExceptioncCarData(areaCode?: string,limit?: string) {
  return request.get('supervise/exception/car', {
    params: {
      areaCode,
      limit
    }
  })
}
// 未绑定手机号列表
export async function GetUnBindPage(areaCode?: string,) {
  return request2.get('tvs-traffic/p-api/v2/supervise/un-bind/page', {
    params: {
      areaCode,
      // limit
    }
  })
}
export async function GetRoadOrderDetail(id?: string,) {
  return request2.get(`tvs-traffic/p-api/v2/supervise/road-order/detail/${id}`, {
   
  })
}

export async function GetBlindSpotData(
  areaCode?: string) {
  return request.get('grovern/blind-spot', {
    params: {
      areaCode
    }
  })
}
// 停车盲点数
export async function GetBlindSpotDataV2(
  areaCode?: string) {
  return request2.get('tvs-traffic/p-api/v2/grovern/blind-spot', {
    params: {
      areaCode
    }
  })
}
export async function GetBlindSpotRoadData( areaCode?: string ,limit?:string) {
  return request.get('grovern/blind-spot-road', {
    params: {
      areaCode,
      limit
    }
  })
}
export async function GetGrovernRequireData(areaCode?:string,limit?:string) {
  return request.get<API.GrovernRequireData[]>('grovern/parking-demand', {
    params: {
      areaCode,
      limit
    }
  })
}
// 停车需求
export async function GetGrovernRequireDataV2(areaCode?:string,limit?:string) {
  return request2.get<API.GrovernRequireData[]>('tvs-traffic/p-api/v2/grovern/parking-demand', {
    params: {
      areaCode,
      limit
    }
  })
}

export async function GetGrovernFeedbackData(areaCode?:string) {
  return request.get<API.GrovernFeedbackData[]>('grovern/feedback', {
    params: {
      areaCode
    }
  })
}

// 群众反应问题
export async function GetGrovernFeedbackDataV2(areaCode?:string) {
  return request2.get<API.GrovernFeedbackData[]>('tvs-traffic/p-api/v2/grovern/feedback', {
    params: {
      areaCode
    }
  })
}

export async function GetDifficultGridData(
  areaCode?: string) {
  return request.get<API.DifficultGridData>('grovern/difficult-grid', {
    params: {
      areaCode
    }
  })
}

export async function GetGrovernUseRateFourData(
  areaCode?: string) {
  return request.get<API.GrovernUseRateData>('grovern/use-rate-four', {
    params: {
      areaCode
    }
  })
}
export async function GetGrovernUseRateOneData(
  areaCode?: string) {
  return request.get<API.GrovernUseRateData>('grovern/use-rate-one', {
    params: {
      areaCode
    }
  })
}
export async function GetGrovernUseRateThreeData(
  areaCode?: string) {
  return request.get<API.GrovernUseRateData>('grovern/use-rate-three', {
    params: {
      areaCode
    }
  })
}
export async function GetGrovernUseRateTwoData(
  areaCode?: string) {
  return request.get<API.GrovernUseRateData>('grovern/use-rate-two', {
    params: {
      areaCode
    }
  })
}
export async function GetGrovernParkUseRateFourData(
  areaCode?: string
  ) {
  return request.get<API.GrovernUseRateData>('grovern/park-use-rate-four', {
    params: {
      areaCode,
      status:'Y'
    }
  })
}
export async function GetGrovernParkUseRateOneData(
  areaCode?: string) {
  return request.get<API.GrovernUseRateData>('grovern/park-use-rate-one', {
    params: {
      areaCode,
      status:'Y'
    }
  })
}
export async function GetGrovernParkUseRateThreeData(
  areaCode?: string) {
  return request.get<API.GrovernUseRateData>('grovern/park-use-rate-three', {
    params: {
      areaCode,
      status:'Y'
    }
  })
}
export async function GetGrovernParkUseRateTwoData(
  areaCode?: string) {
  return request.get<API.GrovernUseRateData>('grovern/park-use-rate-two', {
    params: {
      areaCode,
      status:'Y'
    }
  })
}

export async function GetAreaStaticData(
  cityCode?: string) {
  return request.get<API.AreaStaticData>('area/static', {
    params: {
      cityCode
    }
  })
}



export async function GetParkInfo(params: {
  parkId: string;
  date: string;
  time: string;
}) {
  return request.get<API.ParkInfo>('/park_resource/default/road_size/park_click', {
    params
  })
}
export async function GetparklotInfo(params: {
  parkId: string;
  queryTime: string;
}) {
  return request.get<API.RoadDetail>('park-lot/detail', {
    params
  })
}
export async function GetParkLotOrderList(params: {
  parkId: string;
  pageNum?: string;
  pageSize?: string;
}) {
  return request.get('park-lot/park-order', {
    params
  })
}

export async function GetstaffInfo(params: {
  eventManageId?: string;
  pageNum?: string;
  pageSize?: string;
}) {
  return request.get('inspector-lot/get-work-order', {
    params
  })
}
export async function GetreportInfo(params: {
  pageNum?: string;
  pageSize?: string;
}) {
  return request.get('resource/inspector/report', {
    params
  })
}
export async function GetRoadInfo(params: {
  roadSectionId: string;
  queryTime: string;
}) {
  return request.get<API.RoadDetail>('road-section/detail', {
    params
  })
}
export async function GetRoadprogram(params: {
  roadSectionId: string;
}) {
  return request.get<API.RoadDetail>('road-section/program', {
    params
  })
}
export async function GetInspectorInfont(params: {
  id: string;
}) {
  return request.get('inspector-lot/get-inspector', {
    params
  })
}
export async function Getparklotprogram(params: {
  parkId: string;
}) {
  return request.get<API.RoadDetail>('park-lot/in-out', {
    params
  })
}

export async function GetAreaInfo(params: {
  areaId: string;
  date: string;
  time: string;
}) {
  return request.get<API.AreaInfo>('/park_resource/default/area_size/click', {
    params
  })
}

export async function GetCarParkInfo(orderNo: string) {
  return request.get<API.CarParkInfo>('/park_resource/default/search/clilck/type_one', {
    params: {
      orderNo
    }
  })
}
export async function GetStreetparking(data: {
  roadSectionId: string;
  areaCode?: string;
  queryTime?:string;
}) {
  return request.get('parking-no',{
    params: data
  })
}

export async function GetStreetParkInfo(data: {
  roadSectionId: string;
  berthId: string;
  queryTime?:string;
}) {
  return request.get<API.StreetParkInfo>('parking-no/detail',{
    params: data
  })
}
export async function GetStreetParkList(data: {
  berthId?: string;
  berthNo?:string;
  plateNo?:string;
  queryTime?:string;
  pageNum?:string;
  pageSize?: string;
}) {
  return request.get('parking-no/berth-order-detail',{
    params: data
  })
}
export async function GetStreetParkImage(orderId: string) {
  return request.get('parking-no/photo', {
    params: {
      orderId
    }
  })
}

export async function GetOperateIncome(areaCode?:string) {
  return request.get<API.OperateIncome>('operate/income/add-income/rank',{
    params:{
      areaCode
    }
  })
}


export async function GetSummaryTrafficInfo(areaCode?: string) {
  return request.get<API.SummaryTrafficData>('/park_resource/traffic_count', {
    params: {
      areaCode
    }
  })
}

export async function GetSummaryUserInfo(areaCode?: string) {
  return request.get<API.SummaryUserData>('/park_resource/summary_count', {
    params: {
      areaCode
    }
  })
}

export async function GetSummaryEffectiveInfo(areaCode?: string) {
  return request.get<API.SummaryEffectiveData>('/park_effective/summary_count', {
    params: {
      areaCode
    }
  })
}

export async function GetAlarmCountData(areaCode?: string) {
  return request.get<API.AlarmCountData>('/park_resource/alarm_count', {
    params: {
      areaCode
    }
  })
}

export async function GetAlarmTypeInfo(areaCode?: string) {
  return request.get<API.AlarmTypeList>('/park_resource/get_alarm_one', {
    params: {
      areaCode
    }
  })
}

export async function GetAlarmListByType(params: {
  areaCode?: string;
  alarmType: number;
}) {
  return request.get<API.AlarmList>('/park_resource/get_alarm_two', {
    params
  })
}

export async function GetGridInfo(subZoneId: string) {
  return request.get<API.GridInfo>('/zone/detail', {
    params: {
      subZoneId
    }
  })
}
export async function GetGridInfoV2(subZoneId: string) {
  return request2.get<API.GridInfo>('tvs-traffic/p-api/v2/zone/detail', {
    params: {
      subZoneId
    }
  })
}

export async function GetParkingSummary(params: {
  areaCode?: string
}) {
  return request.get<API.ParkingSummary>('/park_resource/park_num/get', {
    params
  })
}

export async function GetZoneList() {
  return request.get<API.ZoneItem[]>('/zone')
}

export async function GetParkCount(params: {
  areaCode?: string
  zoneId: string
}) {
  return request.get<API.ParkCountItem[]>('/park_resource/park_count/get', {
    params
  })
}

export async function GetParkTimeWithZone(params: {
  areaCode?: string
}) {
  return request.get<API.ZoneParkTime>('/park_resource/park_time/get', {
    params
  })
}

export async function GetBusyParkOrRoad(params: {
  areaCode?: string
}) {
  return request.get<API.BusyArea[]>('/park_resource/park_diffcult/get', {
    params
  })
}

export async function GetRatioDataByType(
  areaCode?: string) {
  return request.get<API.ConverRatioData[]>('resource/industry', {
    params:{
      areaCode
    }
  })
}

export async function GetRatioData(
  areaCode?: string) {
  return request.get('resource/screen-zone', {
    params:{
      areaCode
    }
  })
}

export async function GetUseRatioByZone(params: {
  areaCode?: string
  zoneId: string
}) {
  return request.get<API.UseRatioItem[]>('/park_resource/use_ratio/get', {
    params
  })
}

export async function GetInspectorList(areaCode?: string) {
  return request.get<API.InspectorItem[]>('/park_resource/inspector/get_data', {
    params: {
      areaCode
    }
  })
}

export async function GetParkingNumberInfo(params: {
  areaCode?: string;
  zoneId?: string;
}) {
  return request.get<API.ParkingNumberData[]>('/park_effective/park_count/get', {
    params
  })
}

export async function GetGridUsageInfo(areaCode?: string) {
  return request.get<API.GridUsageData>('/park_effective/use_ratio/all', {
    params: {
      areaCode
    }
  })
}

export async function GetGridUsageLineInfo(params: {
  areaCode?: string;
  zoneId?: string;
}) {
  return request.get<API.GridUsageLineData[]>('/park_effective/use_ratio/by_city_zone', {
    params
  })
}

export async function GetFocusRatioInfo(areaCode?: string) {
  return request.get<API.FocusRatioData[]>('/park_effective/focus_ratio/by_city', {
    params: {
      areaCode
    }
  })
}

export async function GetSummaryTrendInfo(areaCode?: string) {
  return request.get<API.SummaryTrendData>('/park_trend/summary_count', {
    params: {
      areaCode
    }
  })
}

export async function GetGridFocusInfo(areaCode?: string) {
  return request.get<API.GridFocusData>('/park_trend/focus_ratio/all', {
    params: {
      areaCode
    }
  })
}

export async function GetGridFocusLineInfo(params: {
  areaCode?: string;
  zoneId?: string;
}) {
  return request.get<API.GridFocusLineData[]>('/park_trend/facus_ratio/by_city_zone', {
    params
  })
}

export async function GetParkLevelInfo(areaCode?: string) {
  return request.get<API.ParkLevelData[]>('/park_trend/park_level/by_city', {
    params: {
      areaCode
    }
  })
}

export async function GetParkNervousInfo(areaCode?: string) {
  return request.get<API.ParkNervousData[]>('/park_trend/park_nervous/by_city', {
    params: {
      areaCode
    }
  })
}

export async function GetTopNervousInfo(areaCode?: string) {
  return request.get<API.TopNervousData[]>('/park_trend/park_nervous/top', {
    params: {
      areaCode
    }
  })
}

export async function GetParkGapInfo(areaCode?: string) {
  return request.get<API.ParkGapData[]>('/park_trend/park_gap/by_street_park', {
    params: {
      areaCode
    }
  })
}

export async function GetSummaryMonitorInfo(areaCode?: string) {
  return request.get<API.SummaryMonitorData>('/park_monitor/summary_count', {
    params: {
      areaCode
    }
  })
}

export async function GetParkInInfo(areaCode?: string) {
  return request.get<API.ParkInData[]>('/park_monitor/park_new/in_park', {
    params: {
      areaCode
    }
  })
}

export async function GetParkActiveInfo(params: {
  areaCode?: string;
  zoneId?: string;
}) {
  return request.get<API.ParkActiveData[]>('/park_monitor/active_plate/by_city_zone', {
    params
  })
}

export async function GetParkMonitorInfo(params: {
  areaCode?: string;
  zoneId?: string;
}) {
  return request.get<API.ParkMonitorData[]>('/park_monitor/important_plate/by_city_zone', {
    params
  })
}

export async function GetSummaryGovInfo(areaCode?: string) {
  return request.get<API.SummaryGovData>('/park_govern/summary_count', {
    params: {
      areaCode
    }
  })
}

export async function GetParkBlindInfo(areaCode?: string) {
  return request.get<API.ParkBlindData>('/park_govern/blind_info', {
    params: {
      areaCode
    }
  })
}

export async function GetTopBlindInfo(areaCode?: string) {
  return request.get<API.TopBlindData[]>('/park_govern/blind_top', {
    params: {
      areaCode
    }
  })
}

export async function GetParkGovCountInfo(areaCode?: string) {
  return request.get<API.ParkGovCountData[]>('/park_govern/use_ratio/count_and_gap', {
    params: {
      areaCode
    }
  })
}

export async function GetParkGovUseInfo(areaCode?: string) {
  return request.get<API.ParkGovUseData>('/park_govern/use_ratio/by_time', {
    params: {
      areaCode
    }
  })
}

/**停车资源统计 */
export async function GetParkResourceStatic(areaCode?: string) {
  return request.get<API.GetParkResourceStatic>('resource/total-static', {
    params: {
      areaCode
    }
  })
}
/**停车资源统计v2 */
export async function GetParkResourceStaticV2(areaCode?: string) {
  return request2.get<API.GetParkingStatistics>('tvs-traffic/p-api/v2/resource/total-static', {
    params: {
      areaCode
    }
  })
}
/**停车经营统计 */
export async function GetincomesourceStatic(areaCode?: string,cityCode?: string) {
  return request.get('operate/static', {
    params: {
      areaCode,
      cityCode
    }
  })
}
/**停车经营统计 */
export async function GetincomesourceStaticV2(areaCode?: string,cityCode?: string) {
  return request2.get('tvs-traffic/p-api/v2/operate/static', {
    params: {
      areaCode,
      cityCode
    }
  })
}
/**停车监管* */
export async function GetSuperviseStatic(areaCode?: string) {
  return request.get('supervise/static', {
    params: {
      areaCode
    }
  })
}
export async function GetSuperviseTwoStatic(areaCode?: string) {
  return request.get('supervise/static-two', {
    params: {
      areaCode
    }
  })
}
/**停车难治理 */
export async function GetGrovernStatic(areaCode?: string) {
  return request.get('grovern/static', {
    params: {
      areaCode
    }
  })
}
/**停车难治理 */
export async function GetGrovernStaticV2(areaCode?: string) {
  return request2.get('tvs-traffic/p-api/v2/grovern/static', {
    params: {
      areaCode
    }
  })
}
/**套牌车列表 */
export async function GetPlatedeck( params:{
  keyword?: string
  pageNum?: string
  pageSize?: string
}) {
  return request.get('resource/get-plate-deck', {
    params
  })
}
/**敏感车首页 */
export async function GetPlatesensitive( params:{
  keyword?: string
  pageNum?: string
  pageSize?: string
}) {
  return request.get('resource/get-plate-sensitive', {
    params
  })
}
/**僵尸车辆列表 */
export async function GetPlatezombie( params:{
  keyword?: string
  pageNum?: string
  pageSize?: string
}) {
  return request.get('resource/get-plate-zombie', {
    params
  })
}
/**设备报警列表 */
export async function GetPlatetraffic( params:{
  keyword?: string
  pageNum?: string
  pageSize?: string
}) {
  return request.get('resource/traffic/page', {
    params
  })
}
/**设备报警列表 */
export async function Getroadirregularparking( params:{
  areaCode?: string
  keyword?: string
  pageNum?: string
  pageSize?: string
}) {
  return request.get('resource/road-irregular-parking', {
    params
  })
}
/*上报事件列表 */
export async function GetInspectorgReport( params:{
  areaCode?: string
  keyword?: string
  pageNum?: string
  pageSize?: string
}) {
  return request.get('resource/inspector/report/list', {
    params
  })
}
/*未知订单列表 */
export async function GetUnknownOrderlist( params:{
  areaCode?: string
  pageNum?: string
  pageSize?: string
}) {
  return request.get('resource/unknown/order/list', {
    params
  })
}
// 大屏-投诉建议扇形图
export async function GetComplaintAnalysis( params:{
  areaCode?: string
}) {
  return request.get('supervise/dataTypeCount', {
    params
  })
}

//违停高发区
export async function GetIllegalParkV2( params:{
  areaCode?: string 
}) {
  return request2.get('/tvs-traffic/p-api/v2/supervise/zone/illegal-park', {
    params
  })
}

//实时车辆
export async function GetRealTimeCar( params:{
  areaCode?: string 
}) {
  return request2.get('/tvs-traffic/p-api/v2/supervise/park-order/current', {
    params
  })
}
//实时车辆分页
export async function GetRealTimeCarPage( params:{
  areaCode?: string 
  pageNum?: number
  pageSize?: number
}) {
  return request2.get('/tvs-traffic/p-api/v2/supervise/park-order/current/page', {
    params
  })
}

//数据接入质量
export async function GetDataAccessQuality( params:{
  areaCode?: string 
}) {
  return request2.get('/tvs-traffic/p-api/v2/supervise/park/data-quality', {
    params
  })
}
//车场接入情况
export async function GetParkAccess( params:{
  areaCode?: string 
}) {
  return request2.get('/tvs-traffic/p-api/v2/supervise/park/access', {
    params
  })
}
//停车盲点引流(车场)
export async function GetParkScotomaDrainage( params:{
  areaCode?: string 
  limit?:string
}) {
  return request2.get('/tvs-traffic/p-api/v2/grovern/park/blind-spot/traffic', {
    params
  })
}
//停车盲点引流(路段)
export async function GetRoadScotomaDrainage( params:{
  areaCode?: string 
  limit?:string
}) {
  return request2.get('/tvs-traffic/p-api/v2/grovern/road/blind-spot/traffic', {
    params
  })
}

//车位紧张度分析(车场)
export async function GetParkSpaceTension( params:{
  areaCode?: string 
  limit?:string
}) {
  return request2.get('/tvs-traffic/p-api/v2/grovern/park/blind-spot/nervous', {
    params
  })
}
//车位紧张度分析(路段)
export async function GetRoadSpaceTension( params:{
  areaCode?: string 
  limit?:string
}) {
  return request2.get('/tvs-traffic/p-api/v2/grovern/road/blind-spot/nervous', {
    params
  })
}

//大屏-停车时长规律
export async function GetParkingDuration( params:{
  areaCode?: string 
}) {
  return request.get('supervise/parking/duration/statistics', {
    params
  })
}
// 大屏-错时潜力挖掘
export async function GetParkingPotential( params:{
  areaCode?: string 
}) {
  return request.get('supervise/get-road-order/by-berth_id', {
    params
  })
}

//停车难网格分析
export async function GetParkingDifficultyGridAnalysis( params:{
  areaCode?: string 
}) {
  return request.get('supervise/get-parking-zone-data', {
    params
  })
}
//获取网格列表(缺口分析)
export async function GetGridList( params:{
  areaCode?: string 
}) {
  return request2.get('/tvs-traffic/p-api/v2/zone/gap', {
    params
  })
}

//车位紧张车场排名
export async function GetParkSpaceTensionRank( params:{
  areaCode?: string 
}) {
  return request2.get('/tvs-traffic/p-api/v2/grovern/park/blind-spot/nervous', {
    params
  })
}

//支付服务统计折线图(趋势)
export async function GetPaymentServiceStatisticsTrend( params:{
  areaCode?: string 
}) {
  return request.get('server/pay-amount/statistic', {
    params
  })
}

// 支付服务统计折线图(渠道)
export async function GetPaymentServiceStatisticsChannel( params:{
  areaCode?: string 
}) {
  return request.get('server/pay-mode/statistic', {
    params
  })
}

//支付服务统计
export async function GetPaymentServiceStatisticsTotal( params:{
  areaCode?: string 
}) {
  return request.get('server/pay/statistic', {
    params
  })
}
//停车供需分析
export async function GetParkingSupplyDemandAnalysis( params:{
  areaCode?: string 
}) {
  return request.get('supervise/get-data-report-yesterday-list', {
    params
  })
}
//停车指数
export async function GetParkingIndex( params:{
  areaCode?: string 
}) {
  return request.get('supervise/get-parking-index-mark-list', {
    params
  })
}

//活跃用户
export async function GetActiveUser( params:{
  areaCode?: string 
}) {
  return request.get('server/activity/users', {
    params
  })
}

//线上活跃用户(月每天)
export async function GetActiveUserMonth( params:{
  areaCode?: string 
}) {
  return request.get('server/activity/users/month', {
    params
  })
}

//停放车辆分析-绑定车分析
export async function GetParkingVehicleAnalysis( params:{
  areaCode?: string 
}) {
  return request.get('supervise/get-bind-plate-ratio', {
    params
  })
}

//停放车辆分析-活跃车辆-保有量
export async function GetParkingVehicleAnalysisActive( params:{
  areaCode?: string 
}) {
  return request.get('supervise/get-car-inventory', {
    params
  })
}

//停放车辆分析-月卡车-临停车分析
export async function GetMonthCardAnalysis( params:{
  areaCode?: string 
}) {
  return request.get('supervise/get-month-car-plate-ratio', {
    params
  })
}
//停车资源平衡指数
export async function GetParkingResourceBalanceIndex( params:{
  areaCode?: string 
}) {
  return request.get('supervise/get-zone-index-mark-data', {
    params
  })
}
//错时服务数据统计
export async function GetWrongTimeServiceData( params:{
  areaCode?: string 
}) {
  return request.get('server/get-road-order/wrong-time/service', {
    params
  })
}
//服务成效分析
export async function GetServiceEffectAnalyse( params:{
  areaCode?: string 
}) {
  return request.get('server/get-service-effect-analyse', {
    params
  })
}
//停车服务次数
export async function GetParkingServiceCount( params:{
  areaCode?: string 
}) {
  return request.get('server/park/service', {
    params
  })
}

